import Image from 'next/future/image';
import { useContext } from 'react';
import cn from 'classnames';
import allDeals from '@/public/images/categories/all-deals.png';
import smartphones from '@/public/images/categories/Smartphones.png';
import laptops from '@/public/images/categories/Laptops.png';
import smartwatches from '@/public/images/menu/Smartwatch.png';
import iPads from '@/public/images/menu/iPads.png';
import audio from '@/public/images/menu/Audio.png';
import kitchen from '@/public/images/menu/Kitchen.png';
import more from '@/public/images/categories/products.png';
import gaming from '@/public/images/menu/Gaming.png';
import accessories from '@/public/images/menu/access.png';
import outdoor from '@/public/images/menu/outdoor.png';
import cameras from '@/public/images/categories/Cameras.png';
import beauty from '@/public/images/categories/beauty.png';
import vacuum from '@/public/images/categories/Vacuum.png';
import tv from '@/public/images/categories/TVs.png';
import { QsContext } from '@/lib/use-qs';
import useRouterTransition from '@/lib/use-router-transition';
import CustomSlider from '@/components/commons/custom-slider/Slider';

const getCategoryImage = (handle: string | undefined) => {
  if (!handle) return '';

  const images: { [key: string]: StaticImageData } = {
    smartphones,
    laptops,
    smartwatches,
    tablets: iPads,
    earphones: audio,
    cameras,
    tv,
    others: more,
    'gaming consoles': gaming,
    'phone accessories': accessories,
    'e-scooters': outdoor,
    'health-beauty': beauty,
    'vacuum cleaners': vacuum,
    'kitchen appliances': kitchen,
  };

  return images[handle];
};

const CategoryButton = ({
  isTransitioning,
  title,
  onButtonClick,
  src,
  alt,
  reset,
  isActive,
}: {
  isTransitioning: boolean;
  onButtonClick?: (type: string) => void;
  reset?: () => void;
  title: string;
  src: StaticImageData | string;
  alt: string;
  isActive: boolean;
}) => (
  <button
    type="button"
    className={cn(
      { 'border border-gray-700 bg-white': isActive },
      { '!bg-gray-200': !isActive },
      'flex h-10 shrink-0 items-center rounded-full px-3',
    )}
    onClick={() =>
      (reset && reset()) || (onButtonClick && onButtonClick(title))
    }
    disabled={isTransitioning}
  >
    <div className="h-12 w-10">
      <Image
        width={100}
        height={100}
        className="h-full w-full object-contain"
        src={src}
        alt={alt}
        quality={100}
      />
    </div>
    <span className="w-full truncate text-center text-xs">{title}</span>
  </button>
);

const CategoryFilter = ({
  topCategories,
}: {
  topCategories: string[] | undefined;
}) => {
  const [qs, updateQs] = useContext(QsContext);
  const isTransitioning = useRouterTransition();

  if (!topCategories || !topCategories?.length) return null;
  const categoriesQS = qs?.categories?.split('|') || [];

  const onButtonClick = (type: string) => {
    const newCategoriesQS = [...categoriesQS];

    if (categoriesQS.includes(type))
      newCategoriesQS.splice(categoriesQS.indexOf(type), 1);
    else newCategoriesQS.push(type);

    updateQs({ categories: newCategoriesQS.join('|') });
  };

  const reset = () => updateQs({ categories: undefined });

  return (
    <div className="relative">
      <CustomSlider>
        <>
          <CategoryButton
            src={allDeals}
            isTransitioning={isTransitioning || !categoriesQS.length}
            reset={reset}
            title="All Deals"
            alt="All Deals button"
            isActive={!categoriesQS.length}
          />
          {topCategories.map((category, index) => (
            <CategoryButton
              key={index}
              src={getCategoryImage(category.toLocaleLowerCase())}
              isTransitioning={isTransitioning}
              onButtonClick={onButtonClick}
              title={category}
              alt={`${category}-button`}
              isActive={categoriesQS.includes(category)}
            />
          ))}
        </>
      </CustomSlider>
    </div>
  );
};

export default CategoryFilter;
